import styled from "styled-components";

export const InputField = styled.input`
  margin: 2px 0px;
  padding: 10px;
  border-radius: 7px;
  border: 1px solid #dde5ed;
`;
export const SelecField = styled.select`
  margin: 2px 0px;
  padding: 10px;
  border-radius: 7px;
  border: 1px solid #dde5ed;
  width: 100%;

  /* -moz-appearance: none;
  &:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #000;
  }
  -webkit-appearance: none; */
`;

export const ParentRadio = styled.div`
  display: flex;
  flex-direction: column;
  align-items: self-start;
`;

export const RadioField = styled.div`
  margin: 6px 0px;
  display: flex;
  align-items: center;
`;

export const Radio = styled.input`
  border: #eaedf1;
  box-shadow: 0px 4px 10px rgba(234, 237, 241, 0.6);
`;

export const labelRadio = styled.label`
  color: #6c6c6c;
  font-size: 12px;
  font-weight: 400;
  padding: 0px 12px;
`;
